import src from "IMAGE";
export default { src, width: 1773, height: 1772, blurWidth: 0, blurHeight: 0};
